export enum ApplianceDetailsSteppedFormField {
  ApplianceCategoryCode = 'applianceCategoryCode',
  ApplianceCode = 'applianceCode',
  BrandCode = 'brandCode',
  ModelAndSerialNumber = 'modelAndSerialNumber',
  PurchaseDate = 'purchaseDate',
  PurchasePrice = 'purchasePrice',
  PersonalDetails = 'personalDetails',
  IpsPersonalDetails = 'personalDetails',
}
